/** Journey page ids used by AA rollout gating (see BUSINESS_LOAN_JOURNEY_PAGES in utils.js). */
const CHOICE = 10;
const AA_FLOW = 11;
const BANKING = 3;
const AA_ONLY_PAGES = new Set([CHOICE, AA_FLOW]);

function parseGlidListEnv(envValue) {
  return String(envValue || "")
    .split(",")
    .map((entry) => entry.trim())
    .filter(Boolean);
}

/**
 * Phased AA rollout is active when allowlist env vars are set.
 * Remove env vars (or this module's call sites) for 100% go-live.
 */
export function isAaRolloutLimited() {
  return Boolean(
    process.env.REACT_APP_AA_ACTIVE_GLIDS?.trim() ||
      process.env.REACT_APP_AA_ACTIVE_GLIDS_ENDING?.trim()
  );
}

/** Whether this glid gets Choice + AA flow. When rollout is off, all glids are AA-live. */
export function isAaLive(glid) {
  if (!isAaRolloutLimited()) return true;
  if (!glid) return false;

  const normalizedGlid = String(glid).trim();
  const exactGlids = parseGlidListEnv(process.env.REACT_APP_AA_ACTIVE_GLIDS);
  const glidEndings = parseGlidListEnv(process.env.REACT_APP_AA_ACTIVE_GLIDS_ENDING);

  if (exactGlids.includes(normalizedGlid)) return true;
  return glidEndings.some((ending) => normalizedGlid.endsWith(ending));
}

/** First banking step: Choice (10) for AA-live glids, manual upload (3) otherwise. */
export function resolveBankingEntryPage(glid) {
  return isAaLive(glid) ? CHOICE : BANKING;
}

/**
 * Non-AA users must not stay on Choice/AA pages; manual banking (3) is always allowed.
 * AA-live users may still reach page 3 via Choice → Upload manually.
 */
export function guardAaOnlyPage(glid, pageId) {
  const page = Number(pageId);
  if (!isAaRolloutLimited()) return page;
  if (!isAaLive(glid) && AA_ONLY_PAGES.has(page)) return BANKING;
  return page;
}

/** Quick-fetch on manual banking — AA-live users only (everyone at full rollout). */
export function showBankingAaQuickFetch(glid) {
  return isAaLive(glid);
}
